import { mlflowApiClient } from '@/shared/api/core/axios-instance';

export const downloadArtifact = async (runUuid: string, path: string): Promise<Blob> => {
  const response = await mlflowApiClient.get('/get-artifact', {
    params: {
      run_uuid: runUuid,
      path,
    },
    responseType: 'blob',
  });
  return response.data;
};

export const getArtifactUrl = (runUuid: string, path: string): string => {
  return `/artifacts/get-artifact?run_uuid=${runUuid}&path=${encodeURIComponent(path)}`;
};
